import {metadaApi} from '@dms/api/base';
import {BaseVoidResponseSchema} from '@dms/api/shared';

import {
  GetLabourRateApiArg,
  GetLabourRateApiResponse,
  DeleteLabourRateApiResponse,
  DeleteLabourRateApiArg,
  PostLabourRateSetAsActiveApiResponse,
  PostLabourRateSetAsActiveApiArg,
  PostLabourRateSetAsInActiveApiResponse,
  PostLabourRateSetAsInActiveApiArg,
  PostLabourRateApiResponse,
  PostLabourRateApiArg,
  PatchLabourRateApiResponse,
  PatchLabourRateApiArg,
  PostLabourRateApiArgSchema,
  LabourRateApiResponseSchema,
  GetLabourRateApiArgSchema,
  PatchLabourRateApiArgSchema,
  DeleteLabourRateApiArgSchema,
  PostLabourRateSetAsActiveApiArgSchema,
  PostLabourRateSetAsInActiveApiArgSchema,
  GetLabourRatesListApiResponse,
  LabourRatesListApiResponseSchema,
  GetLabourRatesListApiArg,
  GetLabourRatesListApiArgSchema,
  GetHourlyRatesListApiResponse,
  GetHourlyRatesListApiArg,
  GetHourlyRatesListApiArgSchema,
  GetHourlyRatesListApiResponseSchema,
} from './types';

export const metadaWorkshopLabourRateApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    postLabourRate: build.mutation<PostLabourRateApiResponse, PostLabourRateApiArg>({
      query: (queryArg) => ({
        url: `/service/v2/labour-rate`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        responseSchema: LabourRateApiResponseSchema,
        requestSchema: PostLabourRateApiArgSchema,
      },
    }),
    getLabourRate: build.query<GetLabourRateApiResponse, GetLabourRateApiArg>({
      query: (queryArg) => ({
        url: `/service/v2/labour-rate/${queryArg.labourRateId}`,
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [{type: 'labourRate', id: queryArg.labourRateId}],
      extraOptions: {
        responseSchema: LabourRateApiResponseSchema,
        requestSchema: GetLabourRateApiArgSchema,
      },
    }),
    patchLabourRate: build.mutation<PatchLabourRateApiResponse, PatchLabourRateApiArg>({
      query: (queryArg) => ({
        url: `/service/v2/labour-rate/${queryArg.labourRateId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'labourRate', id: queryArg.labourRateId},
      ],
      extraOptions: {
        responseSchema: LabourRateApiResponseSchema,
        requestSchema: PatchLabourRateApiArgSchema,
      },
    }),
    deleteLabourRate: build.mutation<DeleteLabourRateApiResponse, DeleteLabourRateApiArg>({
      query: (queryArg) => ({
        url: `/service/v1/labour-rate/${queryArg.labourRateId}`,
        method: 'DELETE',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'labourRate', id: queryArg.labourRateId},
      ],
      extraOptions: {
        responseSchema: BaseVoidResponseSchema,
        requestSchema: DeleteLabourRateApiArgSchema,
      },
    }),
    postLabourRateSetAsActive: build.mutation<
      PostLabourRateSetAsActiveApiResponse,
      PostLabourRateSetAsActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/labour-rate/${queryArg.labourRateId}/set-as-active`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'labourRate', id: queryArg.labourRateId},
      ],
      extraOptions: {
        responseSchema: BaseVoidResponseSchema,
        requestSchema: PostLabourRateSetAsActiveApiArgSchema,
      },
    }),
    postLabourRateSetAsInActive: build.mutation<
      PostLabourRateSetAsInActiveApiResponse,
      PostLabourRateSetAsInActiveApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/labour-rate/${queryArg.labourRateId}/set-as-inactive`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'labourRate', id: queryArg.labourRateId},
      ],
      extraOptions: {
        responseSchema: BaseVoidResponseSchema,
        requestSchema: PostLabourRateSetAsInActiveApiArgSchema,
      },
    }),
    getLabourRatesList: build.query<GetLabourRatesListApiResponse, GetLabourRatesListApiArg>({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/labour-rate`,
        queryArg,
      }),
      providesTags: ['labourRates'],
      extraOptions: {
        responseSchema: LabourRatesListApiResponseSchema,
        requestSchema: GetLabourRatesListApiArgSchema,
      },
    }),
    getHourlyRatesList: build.query<GetHourlyRatesListApiResponse, GetHourlyRatesListApiArg>({
      query: (queryArg) => ({
        url: '/service/v2/labour-rates',
        queryArg,
      }),
      providesTags: ['hourlyRates'],
      extraOptions: {
        responseSchema: GetHourlyRatesListApiResponseSchema,
        requestSchema: GetHourlyRatesListApiArgSchema,
      },
    }),
  }),
});

export const {
  useGetLabourRateQuery,
  usePostLabourRateMutation,
  usePatchLabourRateMutation,
  useDeleteLabourRateMutation,
  usePostLabourRateSetAsActiveMutation,
  usePostLabourRateSetAsInActiveMutation,
  useGetLabourRatesListQuery,
  useGetHourlyRatesListQuery,
} = metadaWorkshopLabourRateApi;
